/**
 * @file 支持预发环境预览功能的hook
 * @author jiaxuan
 * @date 2022-07-30 16:10:10
 */
import request from '@@/utils/request';
import { useState, useEffect } from 'react';

const usePreviewPage = (pageData) => {
  const [pData, setPageData] = useState(pageData);

  useEffect(() => {
    const init = async () => {
      // 预发环境支持预览功能
      if (location.href.includes('-pre') || process.env.APP_ENV === 'test') {
        if (location?.search && location.search.includes('preview_id=')) {
          const res = await request(`preview${location.search}`);
          if (res) {
            setPageData(res);
          }
        }
      }
    };
    init();
  }, []);

  return pData;
};

export default usePreviewPage;
